<template>
	<SharedButton
		variant="secondary"
		append-icon="social-facebook"
		:icon-prefix="false"
		aria-label="Facebook Anmeldung"
		@click="startFacebookLogin"
	/>
</template>

<script setup lang="ts">
import { pushEvent } from "@/services/dataLayerLogin";
import { store } from "@/state/store";
import SharedButton from "@SharedVueComponents/SharedButton.vue";

function startFacebookLogin() {
	window.location.href = `${store.oAuthSignIn}?kc_idp_hint=facebook`;
	pushEvent("FacebookButton");
}
</script>
